import React, { useState } from 'react';
import { Section } from './ui/Section';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Y si mi hijo se pone peor al inicio?',
    answer: 'Sí: los primeros días puede haber resistencia. Por eso el plan incluye preparación + reemplazo + protocolo de apagado. No improvisas en medio del berrinche, tienes un plan paso a paso para contener la explosión inicial.'
  }, {
    question: '¿Y si mi pareja no apoya?',
    answer: 'El plan parte con alineación mínima de adultos (15 minutos). No necesitas una conferencia familiar ni que estén de acuerdo en todo. Necesitas un acuerdo operativo básico que el plan te ayuda a definir.'
  }, {
    question: '¿Y si tengo hijos de edades diferentes?',
    answer: 'El mecanismo (Triángulo Anti-Pantalla) es el mismo, solo cambian los guiones y los reemplazos. El plan contempla estrategias diferenciadas por etapas: 4-6 años, 7-10 años y 11-15 años.'
  }];
  return <Section background="dark" data-id="element-12">
      <h2 className="text-3xl font-serif font-bold text-white mb-12 text-center" data-id="element-13">
        Preguntas frecuentes
      </h2>

      <div className="space-y-4 max-w-2xl mx-auto" data-id="element-14">
        {faqs.map((faq, index) => <div key={index} className="bg-[#1a2740] rounded-lg overflow-hidden border border-gray-700" data-id="element-15">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-white/5 transition-colors" data-id="element-16">
              <span className="text-lg font-medium text-white" data-id="element-17">
                {faq.question}
              </span>
              {openIndex === index ? <ChevronUp className="w-5 h-5 text-[#c9a84c]" data-id="element-18" /> : <ChevronDown className="w-5 h-5 text-[#c9a84c]" data-id="element-19" />}
            </button>

            <AnimatePresence data-id="element-20">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-21">
                  <div className="p-6 pt-0 text-gray-300 leading-relaxed border-t border-gray-700/50" data-id="element-22">
                    {faq.answer}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}